import api from 'Application/api/api';

const updateGroupInstructionAssignment = (id, data, cancelToken = null) =>
    api.put(`education/instruction-assignments/group/${id}`, data, {
        cancelToken,
    });

export default updateGroupInstructionAssignment;
